import { CursoComplementar } from '@aura/shared.cursos-complementares-frontend';

export const cursosIbmec: CursoComplementar[] = [
  {
    codigo: 'ibmec-padrao-1',
    titulo: 'Conhecendo a área de Carreiras do Ibmec - Orientação profissional',
    url: 'https://play.yduqs.videolib.live/index.html?token=2b558c1f2a264bb6b8e1069026f41ff9',
  },
];
